'use client';

import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { useAnalytics } from '@/services/frontendAnalyticsService';

interface ArticleInlineCTAProps {
  postSlug: string;
  regulationCount?: number;
  shortTitle?: string | null;
  firstRegulationId?: string | null;
}

export function ArticleInlineCTA({
  postSlug,
  regulationCount = 0,
  shortTitle,
  firstRegulationId,
}: ArticleInlineCTAProps) {
  const analytics = useAnalytics();

  let descriptionText: string;

  if (regulationCount >= 2) {
    descriptionText = `Terdapat ${regulationCount} peraturan yang dikutip dalam kajian ini.`;
  } else if (shortTitle) {
    descriptionText = `${shortTitle} dikutip dalam kajian ini.`;
  } else {
    descriptionText = 'Ribuan regulasi tersedia untuk dieksplorasi dan dianalisis.';
  }

  const ctaLink = firstRegulationId
    ? `/regulation/indonesia/${firstRegulationId}`
    : '/legal-tasks/action/search-indonesia-regulation';

  const handleClick = () => {
    analytics.blog.featuresCTAClicked({
      postSlug,
      ctaType: 'analisis',
      ctaLabel: 'Lihat Peraturan di Justisio',
    });
  };

  return (
    <div className="not-prose my-12 bg-white border-2 border-black overflow-hidden md:max-w-[450px] md:mx-auto">
      <div className="p-6 md:p-8">
        <h3 className="text-2xl md:text-3xl font-bold text-black mb-3 leading-tight uppercase font-sans tracking-tight">
          Jangan Hanya Dibaca.
          <br />
          Analisis Sekarang.
        </h3>

        <p className="text-gray-700 font-medium mb-6">
          {descriptionText} Buka Justisio untuk mendapatkan insight lebih dalam.
        </p>

        <Link
          href={ctaLink}
          onClick={handleClick}
          className="inline-flex items-center justify-center gap-2 bg-[#1e3a5f] text-white px-6 py-4 font-bold text-sm md:text-base border-2 border-black hover:bg-[#152d4a] transition-all hover:-translate-y-0.5"
        >
          Lihat Peraturan di Justisio
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  );
}
